// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"e8681b09","124":"c2a9d673","382":"1814e64d","398":"9dae4435","452":"6ab0cc8e","627":"0b685655","641":"dacf1bed","667":"14e6d442","971":"ec2d727f","981":"df50296b","990":"26b09f26"}[chunkId] + ".chunk.js";
};